"use client";

import React from "react";
import { PageTextOnlyCryptoSchema } from "@/sanity/pages/PageTextOnlyCryptoTemplate";
import ScrollingBanner from "../pageComponents/global/ScrollingBanner";
import HeroSection from "../pageComponents/text-only-crypto/Hero";
import ChapterIndex from "../pageComponents/text-only-crypto/ChapterIndex";
import PayoutSection from "../pageComponents/text-only-crypto/PayoutSection";
import ProofsSection from "../pageComponents/text-only-crypto/ProofsSection";
import OfferSection from "../pageComponents/text-only-crypto/OfferSection";
import ReasonsSection from "../pageComponents/text-only-crypto/ReasonsSection";
import WhySection from "../pageComponents/text-only-crypto/WhySection";
import PartnershipSection from "../pageComponents/text-only-crypto/PartnershipSection";
import OriginSection from "../pageComponents/text-only-crypto/OriginSection";
import ReviewStatsSection from "../pageComponents/text-only-crypto/ReviewStatsSection";
import PageFooter from "../pageComponents/text-only-crypto/PageFooter";
import DesignScaleLock from "../global/DesignScaleLock";

/**
 * Figma 7205:2407. No global header or footer: the logo bar is part of the
 * hero frame and the page ships its own footer.
 */
export default function PageTextOnlyCryptoJSX({ data }: { data: PageTextOnlyCryptoSchema }) {
  return (
    <main className="bg-white">
      <DesignScaleLock />
      <HeroSection data={data} />

      {data?.pills && data.pills.length > 0 && (
        <ScrollingBanner
          words={data.pills}
          variant="serif"
          markClassName="text-[#1AA87F]"
          wordClassName="text-[2.25rem] leading-[1.146] tracking-[-0.045rem] lg:text-[2.5rem] lg:tracking-[-0.05rem]"
        />
      )}

      <ChapterIndex titles={data?.chapterTitles} />

      <PayoutSection data={data} />
      <ProofsSection data={data} />
      <OfferSection data={data} />
      <ReasonsSection data={data} />
      <WhySection data={data} />
      <PartnershipSection data={data} />
      <OriginSection data={data} />
      <ReviewStatsSection data={data} />
      <PageFooter data={data} />
    </main>
  );
}
